import React, { useState } from "react";
import Title from "../../components/Title";
import Services from "../../services/services";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { RoutePages } from "../../ultils";

const ForgottenPassword = () => {
    const [step, setStep] = useState(1);
    const [email, setEmail] = useState("");
    const [token, setToken] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmNewPassword, setConfirmNewPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleBegin = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await Services.UserPublic.forgotPasswordBegin(email);
            const data = await res.json();
            if (!res.ok) {
                toast.error(data.error || "Error sending request.");
            } else {
                toast.success(data.message || "Request sent. Please check your email.");
                setStep(2);
            }
        } catch (err) {
            toast.error("Network error. Please try again.");
        }
        setLoading(false);
    };

    const handleFinish = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await Services.UserPublic.forgotPasswordFinish(token, newPassword, confirmNewPassword);
            const data = await res.json();
            if (!res.ok || !data.success) {
                toast.error(data.error || "Error resetting password.");
            } else {
                toast.success(data.message || "Password reset successfully. You can now log in.");
                setStep(1);
                setEmail("");
                setToken("");
                setNewPassword("");
                setConfirmNewPassword("");
                navigate(RoutePages.AUTH.path);
            }
        } catch (err) {
            toast.error("Network error. Please try again.");
        }
        setLoading(false);
    };

    return (
        <>
            <Title page={RoutePages.FORGOTTEN_PASSWORD} title="Forgotten Password" />
            <div className="max-w-md mx-auto mt-10 p-6 bg-white rounded-lg shadow">
                <h2 className="mb-6 text-2xl font-bold text-center">Forgot Password</h2>
                {step === 1 && (
                    <form onSubmit={handleBegin} className="space-y-4">
                        <div>
                            <label className="block mb-1 font-medium">Email used for registration:</label>
                            <input
                                type="email"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                required
                                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring focus:ring-blue-200"
                            />
                        </div>
                        <button type="submit" disabled={loading} className="w-full py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition">
                            {loading ? "Sending..." : "Send Reset Request"}
                        </button>
                    </form>
                )}
                {step === 2 && (
                    <>
                        <button
                            type="button"
                            className="flex items-center px-2 py-1 text-blue-600 hover:text-blue-800"
                            onClick={() => setStep(1)}
                            aria-label="Back"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-6 h-6 mr-1">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                            </svg>
                            Back
                        </button>

                        <form onSubmit={handleFinish} className="space-y-4">
                            <div>
                                <label className="block mb-1 font-medium">Reset Token (from email):</label>
                                <input
                                    type="text"
                                    value={token}
                                    onChange={e => setToken(e.target.value)}
                                    required
                                    className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring focus:ring-blue-200"
                                />
                            </div>
                            <div>
                                <label className="block mb-1 font-medium">New Password:</label>
                                <input
                                    type="password"
                                    value={newPassword}
                                    onChange={e => setNewPassword(e.target.value)}
                                    required
                                    className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring focus:ring-blue-200"
                                />
                            </div>
                            <div>
                                <label className="block mb-1 font-medium">Confirm New Password:</label>
                                <input
                                    type="password"
                                    value={confirmNewPassword}
                                    onChange={e => setConfirmNewPassword(e.target.value)}
                                    required
                                    className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring focus:ring-blue-200"
                                />
                            </div>
                            <button type="submit" disabled={loading} className="w-full py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition">
                                {loading ? "Resetting..." : "Reset Password"}
                            </button>
                        </form>
                    </>
                )}
            </div>
        </>
    );
};

export default ForgottenPassword;